import React from 'react';
import './AppModal.css';
import { FaWindowClose } from 'react-icons/fa';
import { ModalDataType } from '../../common/types';

type PropsType = {
  data: ModalDataType | null;
  setModalData: React.Dispatch<React.SetStateAction<ModalDataType | null>>;
};

const AppModal = ({ data, setModalData }: PropsType) => {
  const className = `AppModal ${data ? 'visible' : 'hidden'}`;
  const { header, body, buttons, comments } = data || {};

  return (
    <div className={ className } role='dialog' aria-modal={ !!data } aria-labelledby='modal-header'>
      <div className='headerWrapper'>
        <h2 id='modal-header' className='header'>{ header }</h2>
        <button
          type='button'
          className='closer'
          onClick={ () => setModalData(null) }
          aria-label='Close dialog'
        >
          <FaWindowClose size='1.5em' className='closeIcon' />
        </button>
      </div>
      {!!data && (
        <>
          <div className='bodyWrapper'>{ body }</div>
          {!!buttons && (
            <div className='buttonsWrapper'>{ buttons }</div>
          )}
          {!!comments && (
            <div className='commentsSection'>
              <hr />
              <p>{ comments }</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AppModal;
